import { Component, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../shared/data-grid/data-grid.template';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PlantService } from '../../../phf/phf.service';
import { FormDialogTemplate } from '../../../../shared/form-dialog/form-dialog.template';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
  selector: 'app-plant',
  templateUrl: './plant.component.html'
})
export class PlantComponent extends DataGridTemplate implements OnInit {
  editForm: FormGroup;
  formDialog: FormDialogTemplate;
  dialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly plantService: PlantService) {
    super();
  }

  ngOnInit() {
    this.httpErrorHeader =  "Stamping Plant Error";
    this.deleteValidation = true;
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.sortable = true;
    this.filterable = "menu";
    this.formDialog.setHeight(480);
    this.controls.excel = true;
    this.editForm = this.formBuilder.group({
      Id: [],
      Name: ['', Validators.required],
      Code: ['', Validators.required],
      IsActive: []
    });

    this.formDialog.initilize(this.dialogTitle, this.editForm, this.formDialogTabs);
    this.dialogTitle.next('Plant');
  }

  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  deleteValidationService = (dataItem: any): Promise<string> => {
    return this.plantService.read('/GetActivePressesParts/' + dataItem.Id, true)
      .then(response => {
        const numParts = response.Parts;
        const numPresses = response.Presses;
        if (numParts !== 0 || numPresses !== 0) {
          return `Are you sure you want to delete ${dataItem.Name}? ${dataItem.Name} has ${numPresses} presses, and ${numParts} parts associated with it.`;
        }
        else {
          return `Are you sure you want to delete ${dataItem.Name}? `;
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.dialogTitle.complete();
  }


  read(opts: any): Promise<any> {
    return opts.force ?
      this.plantService.read('') :
      Promise.resolve(this.plantService.value);
  }


  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.formDialog.next({});
  }

  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    this.formDialog.next(dataItem);
  }


  save(dataItem: any, isNew: boolean): Promise<any> {
    dataItem.IsActive = true;
    return isNew ?
      this.plantService.save(dataItem, isNew, "", false) :
      this.plantService.save(dataItem, isNew, "/" + dataItem.Id, false);
  }

  delete(dataItem: any): Promise<any> {
    return this.plantService.remove("/" + dataItem.Id);
  }

  columns: any[] = [
    {
      field: 'Code',
      title: 'Plant Code',
      width: 180,
      sortable: true,
      filterable: true,
    },
    {
      field: 'Name',
      title: 'Plant Name',
      width: '*',
      sortable: true,
      filterable: true,
    },
  ]


  formControls = [
    {
      type: "text",
      name: "Name",
      title: "Plant Name",
      stretch: true,
    },
    {
      type: "text",
      name: "Code",
      title: "Plant Code",
      stretch: true,
    },
  ]

  formDialogTabs = [
    {
      title: "Plant",
      selected: true,
      formControls: this.formControls
    },
  ]
}
